$(function () {
    if ($('form#ChildcareSiteEditForm').length > 0) {
        $(".lblStopPropagation").on('click touchstart', function (e) { // click or touch on label
            e.stopPropagation();
        });

        //$(".licensecheckbox").on('change', function () {
        //    HandleRoleSelectionOnClicks($(this));
        //});

        if (jsIsAllLicenseSelected) {
            $(".chk-0").prop('checked', true);
        }

        OperatorVisibility();

        $(".btnContinue").on('click', function () {
            $("form").submit();
        });

        function OperatorVisibility() {
            if ($(".home-based-facility:checked").length > 0) {
                $(".operator-role").each(function () {
                    $(this).show();
                });
            } else {
                $(".operator-role").each(function () {
                    $(this).children("input").prop("checked", false);
                    $(this).hide();
                });
            }
        }

        function HandleRoleSelectionOnClicks(self) {
            //number of checked checkboxes
            var noChecked = self.parent().parent().find('.custom-control-input:checked').length;

            //number of all checkboxes
            var noCheckBoxes = self.parent().parent().find('.custom-control-input').length;

            //check all option is now selected
            if (self.siblings(".custom-control-inputvalue").val() == "0") {
                var chkdStatus = self.is(":checked");
                $('.licensecheckbox').prop('checked', chkdStatus);
            }
            else {

                var me = 0;
                if (self.is(":checked")) { me = 1; }

                if (noChecked == 0) {
                    //all are not checked without using all option
                }
                else if (noChecked > 0 && noChecked == noCheckBoxes - me) {
                    //all are checked without using all option
                    $(".chk-0").prop('checked', true);
                }
                else if ($(".chk-0").length == 0 && noChecked == 1 && noChecked == 1) {
                    //only one item so  all option doesn't exist
                }
                else if (noChecked > 0 && noChecked != noCheckBoxes - me) {
                    //one or more licence checked but bnot all of them-for sure without using all option
                    $(".chk-0").prop('checked', false);
                }
            }

            OperatorVisibility();
        }

    }
});